import React, { Component } from 'react';
import { Table, Modal, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class PreviewModal extends Component {
    state = {
        data: [],
        record: {},
        loading: false,
        visible: false,
        pagination: {
            current: 1,
            pageSize: 5,
        },
        sortParams: {},
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
            sortParams: {},
            pagination: {
                current: 1,
                pageSize: 5,
            }
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { searchParams: { inspectionTime } } = this.props;
        const { pagination, record: { leaderUserId } } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryUserInternalRecommendIdInfoList,
            data: {
                userId: leaderUserId,
                inspectionTime,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { userInternalRecommendHistories = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    loading: false,
                    data: userInternalRecommendHistories,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
        }, {
            title: '推荐人员',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            render: (text, record) => {
                const { userCompellation, employeeCode } = record;
                return userCompellation ? `${userCompellation}${employeeCode ? `(${employeeCode})` : ''}` : '';
            }
        }, {
            title: '被推荐人员',
            dataIndex: 'recommendedUserCompellation',
            key: 'recommendedUserCompellation',
            render: (text, record) => {
                const { recommendedUserCompellation, recommendedEmployeeCode } = record;
                return recommendedUserCompellation ? `${recommendedUserCompellation}${recommendedEmployeeCode ? `(${recommendedEmployeeCode})` : ''}` : '';
            }
        }, {
            title: '成功推荐时间',
            dataIndex: 'successRecommendTime',
            key: 'successRecommendTime',
            render: text => text ? text.slice(0, 10) : '',
        }, {
            title: '转正时间',
            dataIndex: 'positiveTime',
            key: 'positiveTime',
            render: text => text ? text.slice(0, 10) : '',
        }];
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, visible, pagination, record: { userCompellation, employeeCode } } = this.state;
        return (
            <Modal
                title='团队推荐转正人员'
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                width="600px"
                maskClosable={false}
                footer={<Button type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div style={{marginBottom: 15}}>
                        团队领导：{`${userCompellation}(${employeeCode})`}
                    </div>
                    <Table
                        bordered
                        loading={loading}
                        pagination={pagination}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={row => row.index}
                        onChange={this.handleTableChange}
                    />
                </div>
            </Modal>
        )
    }
}

export default PreviewModal;


// WEBPACK FOOTER //
// ./src/components/home/teamRecommendTalentRank/PreviewModal.js